import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import '../../styles/core.scss';
import css from './svg-icon.scss';

const SvgIcon = ({ icon = '', className, dataTestId }) => {
  const svg = icon ? <Isvg src={icon} uniquifyIDs cacheRequests /> : '';

  return <div data-testid={dataTestId} className={className || css.svgIconComponent}>{svg}</div>;
};

SvgIcon.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  icon: PropTypes.string
};

export default styleable(css)(SvgIcon);
